import { render, staticRenderFns } from "./FormatComplaint.vue?vue&type=template&id=47230160&scoped=true"
import script from "./FormatComplaint.vue?vue&type=script&lang=js"
export * from "./FormatComplaint.vue?vue&type=script&lang=js"
import style0 from "./FormatComplaint.vue?vue&type=style&index=0&id=47230160&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47230160",
  null
  
)

export default component.exports